export enum SubscriptionStatus {
  InProgress = "In Progress",
  New = "New",
  Active = "Active",
  Cancelled = "Cancelled",
  Expired = "Expired",
  Terminated = "Terminated",
  NotAvailable = "N/A",
}

export enum SubscriptionState {
  ACTIVE = "ACTIVE",
  NEW = "NEW",
  PENDING = "PENDING",
  CANCELLED = "CANCELLED",
  DENIED = "DENIED",
  ONHOLD = "ONHOLD",
  TERMINATED = "TERMINATED",
  EXPIRED = "EXPIRED",
}
